<template>
    <div class="flex" style="height: calc(100vh - 60px); ">
        <div :style="`width: calc(100% - ${chatPanelWidth}); transition: width 0.15s ease-in-out;`">
            <div class="flex no-wrap q-pt-sm q-pr-md" style="position: relative; width: calc(100% / 0.85); transform: scale(0.85); transform-origin: top left; z-index: 1000;">
                <SingleSelect v-model="selectedCycle" :options="cycleOptions" label="CYCLE" placeholder="Select cycle" style="width: 130px; z-index: 1000;" class="q-ml-md" @update:modelValue="fetchBcos"/>
                <SingleSelect v-model="selectedBrand" :options="brandOptions" label="BRAND" placeholder="Select brand" style="width: 130px; z-index: 1000;" class="q-ml-md" @update:modelValue="fetchBcos"/>
                <SingleSelect v-model="selectedStrategicImperative" :options="strategicImperativeOptions" label="STRATEGIC IMPERATIVE" placeholder="Select a strategic imperative" style="width: 230px; z-index: 1000;" class="q-ml-md" @update:modelValue="fetchBcos"/>
                <q-space/>
                <q-btn v-if="canChatAboutBco" unelevated no-caps color="accent" class="insights-agent-btn self-end q-px-md q-ml-md" @click="toggleChat">
                    <q-icon name="chat_bubble" size="16px" class="q-mr-sm"/>
                    <div style="font-size: 13px; font-weight: 600; letter-spacing: 0.5px;">NBA Copilot</div>
                    <q-tooltip>{{ isChatOpen ? 'Close Chat' : 'Ask about this cohort' }}</q-tooltip>
                </q-btn>
                <!-- <TextInput v-model="additionalContext" label="ADDITIONAL CONTEXT" optional placeholder="e.g. prioritise academic centres;" style="width: 280px;" class="q-ml-md"/>
                <q-btn unelevated color="accent" class="q-py-xs q-px-md self-center q-mt-md q-ml-md" style="border-radius: 6px;">
                    <div style="font-size: 12px; font-weight: 600; letter-spacing: 1px;">Run</div>
                </q-btn> -->
            </div>

            <div class="flex full-width" style="border-top: 1px solid #dedede;">
                <!-- Left panel of BCOs list -->
                <div :style="`width: ${bcoPanelWidth}; border-right: 1px solid #dedede; transition: width 0.15s ease-in-out;`">
                    <div v-if="!isBCOPanelOpen" class="flex column items-center bg-grey-2" style="height: calc(100vh - 129px);">
                        <q-btn flat dense icon="chevron_right" size="sm" color="grey-8" class="q-mt-sm" @click="isBCOPanelOpen = true"><q-tooltip>Expand BCOs</q-tooltip></q-btn>
                        <div v-if="bcos?.length > 0 && isBCOPanelOpen" class="q-mt-sm" style="font-size: 11px; font-weight: 600; color: #5f5f5f;">{{ bcos?.length }}</div>
                        <div class="q-mt-md" style="font-size: 11px; font-weight: 600; color: #5f5f5f; writing-mode: vertical-rl; letter-spacing: 1px;">BCOs</div>
                    </div>

                    <q-scroll-area v-else ref="bcoListScroll" :thumb-style="thumbStyle" :horizontal-offset="[0, 1]" class="full-width bg-grey-2" style="height: calc(100vh - 129px);">
                        <div class="flex full-width items-center q-pt-sm q-pb-xs q-pl-md q-pr-sm" style="font-size: 14px; font-weight: 600;">
                            <div>BCOs for this imperative</div>
                            <q-space />
                            <div v-if="bcos?.length > 0">{{ bcos?.length }}</div>
                            <q-btn flat dense icon="chevron_left" size="xs" color="grey-8" class="q-ml-xs" @click="isBCOPanelOpen = false"><q-tooltip>Collapse</q-tooltip></q-btn>
                        </div>
                        
                        <template v-if="selectedStrategicImperative">
                            <template v-if="!loadingBcos">
                                <div class="flex full-width items-center q-px-md" style="font-size: 11px;">
                                    <template v-for="status in ['Feasible', 'Caveat', 'Blocked']">
                                        <i :class="`dot q-mr-xs`" :style="`background: ${chipTextMapping[status]};`"></i>
                                        <div class="q-mr-md">{{ status }}</div>
                                    </template>
                                </div>

                                <div v-if="siThoughtTrace.length" class="si-trace-card">
                                    <SIThoughtTrace :key="selectedStrategicImperative" :data="siThoughtTrace" :animate="!isSiThoughtTraceComplete" @reveal="scrollTraceIntoView('bcoListScroll')" @complete="markSiThoughtTraceSeen"/>
                                </div>

                                <template v-if="showBcoList && bcos?.length > 0">  
                                    <div class="flex full-width" style="padding: 16px 10px 0px 10px;">
                                        <div v-if="existingBcos.length > 0" style="color: #5f5f5f; font-size: 10px; font-weight: 600; letter-spacing: 1px;">APPROVED BCOs</div>

                                        <div v-for="bco in existingBcos" :key="`bco-${bco.bco_id}`" class="bco-card" :class="{ selected: selectedBcoId === bco.bco_id }" @click="handleBcoCardClick(bco.bco_id)">
                                            <div class="flex full-width justify-between items-start">
                                                <div style="font-size: 12px; font-weight: 600; width: 60%;">{{ bco.name }}</div>
                                                <div class="flex items-center" :style="`background: ${chipBGMapping[bco.status]}; border-radius: 10px; padding: 2px 6px; max-width: 40%; width: auto;`">
                                                    <i :style="`background: ${chipTextMapping[bco.status]};`" class="dot q-mr-xs"></i>
                                                    <div :style="`font-size: 10px; font-weight: 600; color: ${chipTextMapping[bco.status]};`">{{ bco.status }}</div>
                                                </div>
                                                <q-icon v-if="bco?.bco_rationale" name="info" size="16px" class="q-ml-xs" color="primary">
                                                    <q-tooltip max-width="300px">{{ bco.bco_rationale }}</q-tooltip>
                                                </q-icon>
                                            </div>
                                            <!-- <div class="flex full-width">
                                                <div v-for="(tag, tagIndex) in bco.tags" :key="`tag-${bco.bco_id}-${tagIndex}`" class="flex items-center q-mt-sm q-py-xs q-px-sm q-mr-sm" style="background-color: #f0f0f0; border: 1px solid #DADADA; border-radius: 10px; width: auto; font-size: 8px; font-weight: 700; color: #5f5f5f;">{{ tag }}</div>
                                            </div> -->
                                            <!-- <div v-if="bco.blocked_msg" class="full-width q-mt-sm text-italic" style="border: 1px solid #ffd3c0; background: #fff1ea; border-radius: 6px; padding: 4px 8px; font-size: 11px; color: #b33700;"><b>Why: </b>{{ bco.blocked_msg }}</div> -->
                                        </div>

                                        <q-separator class="full-width q-mt-md q-mb-sm"/>

                                        <div v-if="agentRecommendedBcos.length > 0" class="flex full-width justify-between items-center">
                                            <div class="text-accent" style="font-size: 10px; font-weight: 600; letter-spacing: 1px;">AGENT RECOMMENDED BCOs</div>
                                        </div>
                                        <div v-if="lastCreatedAtDate" class="text-italic q-mt-xs" style="font-size: 10px; color: #5f5f5f;">Last refreshed: {{ lastCreatedAtDate }}</div>

                                        <div v-for="bco in agentRecommendedBcos" :key="`bco-${bco.bco_id}`" class="bco-card" :class="{ selected: selectedBcoId === bco.bco_id }" @click="handleBcoCardClick(bco.bco_id)">
                                            <div class="flex full-width justify-between items-start">
                                                <div style="font-size: 12px; font-weight: 600; width: 60%;">{{ bco.name }}</div>
                                                <div class="flex items-center" :style="`background: ${chipBGMapping[bco.status]}; border-radius: 10px; padding: 2px 6px; max-width: 40%; width: auto;`">
                                                    <i :style="`background: ${chipTextMapping[bco.status]};`" class="dot q-mr-xs"></i>
                                                    <div :style="`font-size: 10px; font-weight: 600; color: ${chipTextMapping[bco.status]};`">{{ bco.status }}</div>
                                                </div>
                                                <q-icon v-if="bco?.bco_rationale" name="info" size="16px" class="q-ml-xs" color="primary">
                                                    <q-tooltip max-width="300px">{{ bco.bco_rationale }}</q-tooltip>
                                                </q-icon>
                                            </div>
                                            <!-- <div class="flex full-width">
                                                <div v-for="(tag, tagIndex) in bco.tags" :key="`tag-${bco.bco_id}-${tagIndex}`" class="flex items-center q-mt-sm q-py-xs q-px-sm q-mr-sm" style="background-color: #f0f0f0; border: 1px solid #DADADA; border-radius: 10px; width: auto; font-size: 8px; font-weight: 700; color: #5f5f5f;">{{ tag }}</div>
                                            </div> -->
                                            <!-- <div v-if="bco.blocked_msg" class="full-width q-mt-sm text-italic" style="border: 1px solid #ffd3c0; background: #fff1ea; border-radius: 6px; padding: 4px 8px; font-size: 11px; color: #b33700;"><b>Why: </b>{{ bco.blocked_msg }}</div> -->
                                        </div>

                                        <div class="full-width q-py-sm"></div>
                                    </div>
                                </template>
                                <template v-if="showBcoList && bcos.length == 0">
                                    <div class="flex full-width justify-center items-center q-mt-xl">
                                        <div style="font-size: 12px; color: #5f5f5f;">No BCOs found for this strategic imperative</div>
                                    </div>
                                </template>
                            </template>

                            <template v-else>
                                <div class="flex full-width justify-center items-center q-mt-xl">
                                    <q-spinner color="accent" size="20px" class="q-mr-md"/>
                                    <div style="font-size: 12px; color: #5f5f5f;">Loading...</div>
                                </div>
                            </template>
                        </template>
                        <div v-else class="flex full-width justify-center items-center q-mt-xl">
                            <div style="font-size: 12px; color: #5f5f5f;">Select a Strategic Imperative</div>
                        </div>
                    </q-scroll-area>
                </div>

                <!-- Right panel of BCO details -->
                <div :style="`width: calc(100% - ${bcoPanelWidth}); transition: width 0.15s ease-in-out;`">
                    <q-scroll-area ref="bcoDetailScroll" :thumb-style="thumbStyle" :horizontal-offset="[0, 4]" class="full-width q-px-md" style="height: calc(100vh - 129px);">
                        
                        <div class="flex full-width q-py-sm" style="font-size: 14px;">
                            <div v-if="selectedBco" class="text-bold">{{ selectedBco.name }}</div>
                        </div>

                        <template v-if="selectedBco">
                            <div v-if="hasBcoThoughtTrace" ref="bcoTraceCard" class="bco-trace-card">
                                <BCOThoughtTrace :key="`bco-trace-${selectedBcoId}-${bcoThoughtTraceRunId}`" :data="bcoThoughtTrace" :live="isBcoAgentRunning" :animate="animateBcoThoughtTrace" @reveal="scrollTraceIntoView('bcoDetailScroll')" @complete="markBcoThoughtTraceSeen"/>
                            </div>

                            <template v-if="showBcoDetails">
                            <!-- BCO RULE card -->
                            <div class="flex column full-width bg-grey-2" style="border: 1px solid #dedede; border-radius: 8px; padding: 10px 10px 10px 16px; border-left: 4px solid #dedede;">
                                <div style="color: #5f5f5f; font-size: 10px; font-weight: 700; letter-spacing: 1px;">BCO RULE</div>
                                <div class="q-mt-xs" style="font-size: 12px; color: #5f5f5f;">{{ selectedBco.bco_rule }}</div>
                            </div>

                            <!-- WHY THIS BCO WAS RECOMMENDED card -->
                            <template v-if="selectedBco?.type !== 'existing'">
                                <div class="flex column full-width q-mt-md" style="position: relative; border: 1px solid #ffd3c0; border-radius: 8px; padding: 10px 10px 10px 16px; border-left: 4px solid #ffd3c0; background: #fff1ea;">
                                    <AgentTrustScoreButton :scores="recommendationTrustScores" empty-message="Agent trust scores have not been generated for this BCO recommendation yet." class="recommendation-trust-score"/>
                                    <div class="text-secondary" style="font-size: 10px; font-weight: 700; letter-spacing: 1px;">WHY THIS BCO WAS RECOMMENDED</div>
                                    <div class="q-mt-xs text-secondary" style="font-size: 12px; font-weight: 600;"><span style="color: black;">Source:&nbsp;</span>{{ selectedBco?.recommendation_source }}</div>
                                    <div class="q-mt-xs" style="font-size: 12px;">
                                        <div><b>BCO Rationale:</b> {{ selectedBco?.bco_rationale }}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="flex column full-width q-mt-md" style="border: 1px solid #ffd3c0; border-radius: 8px; padding: 10px 10px 10px 16px; border-left: 4px solid #ffd3c0; background: #fff1ea;">
                                    <div class="text-secondary" style="font-size: 12px; font-weight: 600;"><span style="color: black;">Source:&nbsp;</span>{{ selectedBco?.recommendation_source }}</div>
                                    <div class="q-mt-xs" style="font-size: 12px;">
                                        <div><b>Trigger:</b> {{ selectedBco?.trigger_data }}</div>
                                    </div>
                                </div>
                            </template>

                            <!-- LOOKBACK PERIOD card -->
                            <div class="flex column full-width q-mt-md" style="border: 1px solid #dedede; border-radius: 8px; padding: 10px 10px 10px 16px;">
                                <div class="flex full-width justify-between items-center">
                                    <div style="color: #5f5f5f; font-size: 10px; font-weight: 700; letter-spacing: 1px;">LOOKBACK PERIOD</div>
                                    <div>
                                        <q-btn outline rounded no-caps color="secondary" size="sm" class="q-py-none q-px-sm q-mr-sm bg-white" :loading="resettingLookbackPeriod" @click="resetLookbackPeriodToDefaults" :disable="isSimulatingCohort || cohortThresholds.lookback_period_weeks === defaultCohortThresholds.lookback_period_weeks">Reset to default</q-btn>
                                        <q-btn rounded unelevated no-caps color="accent" size="sm" class="q-py-none q-px-sm" :disable="isSimulatingCohort" @click="submitCohortThresholds"><b>Submit</b></q-btn>
                                    </div>
                                </div>

                                <div class="flex items-center full-width q-mt-sm">
                                    <ThresholdSlider
                                        :allowed-values="lookbackAllowedValues"
                                        value-suffix=" wk"
                                        v-model="cohortThresholds.lookback_period_weeks"
                                        style="width: 35%;"
                                    />
                                    <!-- <q-radio
                                        v-for="option in lookbackPeriodOptions"
                                        :key="`lookback-period-${option.value}`"
                                        v-model="cohortThresholds.lookback_period_weeks"
                                        :val="option.value"
                                        :label="option.label"
                                        dense
                                        size="xs"
                                        color="accent"
                                        class="q-mr-lg"
                                        style="font-size: 12px;"
                                        :disable="isSimulatingCohort"
                                    /> -->
                                    <div class="text-italic q-ml-lg" style="font-size: 11px; color: #8d8d8d;">sets the eligible pool the waterfall starts from</div>
                                </div>
                            </div>

                            <!-- DATA FEASIBILITY card -->
                            <div class="flex full-width q-mt-md" style="border: 1px solid #dedede; border-radius: 8px;">
                                <div class="flex full-width justify-between q-px-md q-py-sm bg-grey-2" style="border-bottom: 1px solid #dedede;">
                                    <div style="font-size: 11px; font-weight: 600; letter-spacing: 1px;">DATA FEASIBILITY</div>
                                    <div class="text-italic" style="font-size: 11px; color: #5f5f5f;">GATE = hard blocker</div>
                                </div>

                                <template v-if="!isSimulatingCohort">
                                    <div class="row full-width q-my-sm" style="position: relative;">
                                        <AgentTrustScoreButton :scores="feasibilityTrustScores" empty-message="Agent trust scores have not been generated for this data feasibility check yet. They will appear after the next feasibility run." class="feasibility-trust-score"/>
                                        <div v-for="(data, index) in data_feasibility" :key="`data-feasibility-${index}`" class="flex items-center col-4 q-pr-xl q-pl-md q-my-sm">
                                            <q-icon :name="dataFeasibilityIconMapping[data.status]" size="18px" class="q-mr-xs" :style="`color: ${chipTextMapping[data.status]};`"/>
                                            <div style="font-size: 11px;">{{ data.name }}</div>
                                            <div v-if="data?.is_gate" class="q-ml-sm" style="font-size: 8px; color: #9f9f9f; border: 1px solid #9f9f9f; border-radius: 4px; padding: 2px 4px;">GATE</div>
                                            <q-space/>
                                            <div v-if="data?.value" style="font-size: 10px; color: #5f5f5f;">{{ data.value }}</div>
                                            
                                        </div>
                                    </div>

                                    <div class="full-width q-px-md" style="padding-bottom: 12px;">
                                        <div :style="`background: ${chipBGMapping[selectedBco.status]}; border: 1px solid #dedede; border-radius: 8px; padding: 10px 12px; font-size: 12px; line-height: 1.5;`">
                                            <q-icon :name="dataFeasibilityIconMapping[selectedBco.status]" size="16px" class="q-mr-sm" :style="`color: ${chipTextMapping[selectedBco.status]};`"/>
                                            <span :style="`font-weight: 700; color: ${chipTextMapping[selectedBco.status]};`">{{ recommendationTextMapping[selectedBco.status] }}&nbsp;—&nbsp;</span>
                                            <span class="recommendation-markdown" v-html="markdownToHtml(recommendation_message)"></span>
                                        </div>
                                    </div>
                                </template>

                                <div v-else class="flex full-width q-pa-md">
                                    <q-spinner color="accent" size="20px" class="q-mr-md"/>
                                    <div style="font-size: 12px; color: #5f5f5f;">Checking data feasibility...</div>
                                </div>
                            </div>

                            <!-- COHORT WATERFALL card -->
                            <div v-if="cohort_waterfall?.length && (selectedBco?.status == 'Feasible' || selectedBco?.status == 'Caveat')" class="flex column full-width q-mt-md" style="border: 1.5px solid #ff4e00; border-radius: 8px; padding: 10px 16px 16px 16px;">
                                <div class="flex full-width justify-between items-center q-mb-sm">
                                    <div class="text-accent" style="font-size: 10px; font-weight: 700; letter-spacing: 1px;">COHORT WATERFALL</div>
                                    <div style="color: #acacac; font-size: 10px; font-style: italic;">each rule applied in sequence</div>
                                </div>

                                <div v-if="!isSimulatingCohort" class="flex full-width">
                                    <div class="col q-pr-md">
                                        <div v-for="(step, index) in cohort_waterfall" :key="`cohort-waterfall-${index}`" class="row items-center q-my-xs">
                                            <div class="col-3" style="min-width: 100px; color: #333; font-size: 11px; line-height: 1.1; font-weight: 700;">{{ step[0] }}</div>

                                            <div class="col items-center" style="height: 12px; background: #f0f0f0; border-radius: 4px; display: flex; flex-direction: row;">
                                                <div class="full-height" :style="`width: ${Math.max(0, Math.min(100, (Number(step[1]) / Number(cohort_waterfall[0][1])) * 100))}%; border-radius: 4px; background: #9bb5cc;`"></div>
                                                <div v-if="index > 0" class="text-grey-7" style="padding-left: 6px; font-size: 10px;">-{{ Number(cohort_waterfall[index - 1][1]) - Number(step[1]) }}</div>
                                            </div>

                                            <div class="col-1 text-right" :class="`text-grey-10`" style="font-size: 11px; font-weight: 700; min-width: 28px;">{{ step[1] }}</div>
                                        </div>
                                    </div>

                                    <div class="col-auto flex column justify-center items-center q-pa-sm" style="position: relative; width: 250px; border: 1.5px solid #ff6c2b; border-radius: 8px; background: #fff1ea;">
                                        <q-btn v-if="hasCohortSizeTrend" flat dense round size="sm" color="accent" icon="show_chart" class="cohort-trend-btn" @click="showCohortTrend = true">
                                            <q-tooltip anchor="top middle" self="bottom middle" :offset="[0, 6]" class="bg-grey-9" style="font-size: 10px;">View trend</q-tooltip>
                                        </q-btn>
                                        <div style="color: #a94720; font-size: 10px; font-weight: 700; letter-spacing: 1px;">FINAL HCP COHORT</div>
                                        <div class="q-mt-xs text-accent" style="font-size: 40px; font-weight: 700; line-height: 1;">{{ cohort_waterfall[cohort_waterfall.length - 1][1] }}</div>
                                        <div class="q-mt-xs" style="color: #242424; font-size: 12px; font-weight: 600;">HCPs enter this objective</div>
                                        <div class="q-mt-sm q-pt-sm" style="border-top: 1px solid #f1d8cd; color: #a94720; font-size: 10px;">{{ Math.round(((Number(cohort_waterfall[cohort_waterfall.length - 1][1])) / Number(cohort_waterfall[0][1])) * 100) }}% of {{ cohort_waterfall[0][1] }} eligible · {{ Number(cohort_waterfall[0][1]) - Number(cohort_waterfall[cohort_waterfall.length - 1][1]) }} removed across {{ cohort_waterfall.length - 1 }} rules</div>
                                    </div>
                                </div>

                                <div v-else class="flex full-width items-center">
                                    <q-spinner color="accent" size="20px" class="q-mr-md"/>
                                    <div style="font-size: 12px; color: #5f5f5f;">Simulating cohort...</div>
                                </div>
                            </div>

                            <!-- COHORT SIMULATOR card -->
                            <div v-if="selectedBco?.status == 'Feasible' || selectedBco?.status == 'Caveat'" style="display: flex; flex-direction: column; width: 100%; margin-top: 16px; background: #fff1ea; border: 1px solid #ff4e00; border-radius: 8px; padding: 10px 16px 16px 16px;">
                                <div class="flex full-width justify-between">
                                    <div style="display: flex; align-items: baseline; flex-wrap: wrap;">
                                        <div class="text-secondary" style="font-size: 10px; font-weight: 700; letter-spacing: 1px;">COHORT SIMULATOR</div>
                                        <div style="font-size: 11px; font-style: italic; color: #8d8d8d; margin-left: 8px;">adjust the thresholds and watch the cohort rebuild</div>
                                    </div>

                                    <div style="display: flex; align-items: center; flex-shrink: 0; margin-left: 12px;">
                                        <q-btn outline rounded no-caps color="secondary" size="sm" class="q-py-none q-px-sm q-mr-sm bg-white" :loading="resettingCohort" @click="resetCohortThresholdsToDefaults" :disable="isSimulatingCohort || areCohortThresholdsEqualToDefaults">Reset to defaults</q-btn>
                                        <q-btn rounded unelevated no-caps color="accent" size="sm" class="q-py-none q-px-sm" :disable="isSimulatingCohort" @click="submitCohortThresholds"><b>Submit</b></q-btn>
                                    </div>
                                </div>

                                <div class="full-width q-mt-md" style="display: flex; flex-wrap: wrap; gap: 16px;">
                                    <ThresholdRangeSlider
                                        v-for="simulator in visibleCohortSimulators"
                                        :key="`cohort-simulator-${simulator.key}`"
                                        :label="simulator.label"
                                        :min="simulator.range.min"
                                        :max="simulator.range.max"
                                        :step="simulator.step"
                                        v-model="cohortThresholds[simulator.key]"
                                        style="width: calc(25% - 12px);"
                                    />
                                </div>
                            </div>

                            <!-- RUN BUTTON -->
                            <div v-if="selectedBco?.status != 'Blocked'" class="flex full-width justify-center q-pa-md">
                                <q-btn v-if="selectedBco?.running_status !== 'running'" unelevated color="accent" class="q-py-xs q-px-lg" style="border-radius: 6px;" :loading="triggeringRun" @click="triggerBcoRun">
                                    <div class="flex items-center" style="font-size: 12px; font-weight: 600; letter-spacing: 1px;">Review & Approve</div>
                                </q-btn>

                                <q-btn v-if="selectedBco?.running_status === 'running'" unelevated color="accent" class="q-py-xs q-px-lg" style="border-radius: 6px;" @click="$router.push({ name: 'agent-studio' })">
                                    <div class="flex items-center" style="font-size: 12px; font-weight: 600; letter-spacing: 1px;">View run details</div>
                                </q-btn>
                            </div>
                            </template>
                        </template>

                        <!-- NO BCO SELECTED -->
                        <template v-else>
                            <div class="flex items-center text-center column" style="padding-top: calc((100vh - 450px)/2);">
                                <template v-if="selectedStrategicImperative">
                                    <div style="color: #414141; font-size: 16px; font-weight: 600;">Now pick a business objective</div>
                                    <div class="q-mt-sm" style="color: #858585; font-size: 12px; line-height: 1.45;">
                                        Each is pre-scored so you can triage at a glance. Open one to<br>
                                        simulate the cohort and review feasibility.
                                    </div>
                                </template>
                                <template v-else>
                                    <div style="color: #414141; font-size: 16px; font-weight: 600;">Start by choosing a strategic imperative</div>
                                    <div class="q-mt-sm" style="color: #858585; font-size: 12px; line-height: 1.45;">
                                        The Strategize agent will surface the objectives linked to it —<br>
                                        those already in your plan, and new ones it has found in internal<br>
                                        signals and external events.
                                    </div>
                                </template>

                                <div class="strategy-stepper">
                                    <template v-for="(step, index) in ['Select imperative', 'Choose a BCO', 'Simulate & review', 'Run']" :key="step">
                                        <div class="strategy-step">
                                            <div class="strategy-step-number" :class="{ active: index === strategySelectStepIndex, completed: index < strategySelectStepIndex }">
                                                <q-icon v-if="index < strategySelectStepIndex" name="check" size="14px" />
                                                <template v-else>{{ index + 1 }}</template>
                                            </div>
                                            <div class="strategy-step-label" :class="{ active: index === strategySelectStepIndex }">{{ step }}</div>
                                        </div>
                                        <div v-if="index < 3" class="strategy-step-connector"></div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </q-scroll-area>
                </div>
            </div>
        </div>

        <!-- CHAT PANEL -->
        <div v-if="isChatOpen" :style="`width: ${chatPanelWidth}; height: calc(100vh - 60px); border-left: 1px solid #dedede;`">
            <div class="flex full-width justify-between items-start q-py-sm q-pl-md q-pr-sm" style="border-bottom: 1px solid #dedede;">
                <div class="column">
                    <div style="font-size: 12px; font-weight: 600;">Ask about this cohort</div>
                    <div style="font-size: 10px; color: #858585;">the BCO rule · each waterfall step</div>
                </div>
                <div class="self-center">
                    <q-btn flat no-caps dense color="grey-8" class="q-py-none q-px-xs q-mr-sm" style="border-radius: 6px; font-size: 12px;" @click="showOlderChats = true"><q-icon name="list_alt" size="16px" class="q-mr-xs" /><span>History</span><q-tooltip>View Older Chats</q-tooltip></q-btn>
                    <q-btn flat no-caps dense color="grey-8" class="q-py-none q-px-xs" style="border-radius: 6px; font-size: 12px;" @click="createNewChat"><q-icon name="add" size="16px" class="q-mr-xs" /><span>New</span><q-tooltip>New Chat</q-tooltip></q-btn>
                </div>
                <q-btn flat icon="close" size="xs" color="grey-8" class="q-py-none q-px-xs" style="border-radius: 6px;" @click="isChatOpen = false; isBCOPanelOpen = true"><q-tooltip>Close</q-tooltip></q-btn>
            </div>

            <q-scroll-area class="full-width chat-scroll" :thumb-style="thumbStyle" :horizontal-offset="[0, 0]" :style="{ height: chatScrollHeight }" ref="chatScroll">
                <div v-if="!loadingOldChat" class="flex full-width">
                    <template v-if="qna.length">
                        <div v-for="(msg, msgIndex) in qna" :key="msgIndex" class="full-width flex ">
                            <!-- Question chat bubble -->
                            <div v-if="msg.question" class="flex full-width justify-end q-pr-sm q-mt-sm">
                                <!-- Editing: the bubble becomes an input with its own send button -->
                                <div v-if="editingQnaKey === msg.key" class="question-edit-box q-pa-sm">
                                    <textarea ref="editQuestionInput" v-model="editingQuestionText" class="question-edit-input" rows="2" @keydown.enter.exact.prevent="submitEditedQuestion(msg)" @keydown.esc.prevent="cancelEditQuestion"></textarea>
                                    <div class="flex justify-end items-center q-mt-xs">
                                        <!-- <q-btn flat dense no-caps size="sm" color="grey-8" label="Cancel" class="q-mr-xs q-px-sm" style="border-radius: 6px;" @click="cancelEditQuestion"/>
                                        <q-btn unelevated dense no-caps size="sm" color="accent" label="Send" class="q-px-sm" style="border-radius: 6px;" :disable="!editingQuestionText.trim() || isGenerating" @click="submitEditedQuestion(msg)"/> -->
                                        <q-btn outline rounded no-caps color="secondary" size="sm" class="q-py-none q-px-sm q-mr-sm bg-white" @click="cancelEditQuestion">Cancel</q-btn>
                                        <q-btn rounded unelevated no-caps color="accent" size="sm" class="q-py-none q-px-sm" @click="submitEditedQuestion(msg)" :disable="!editingQuestionText.trim() || isGenerating"><b>Send</b></q-btn>
                                    </div>
                                </div>

                                <div v-else class="question-block">
                                    <q-btn flat dense icon="edit" size="xs" color="grey-8" class="question-edit-btn q-mr-xs" :disable="isGenerating" @click="startEditQuestion(msg)"><q-tooltip>Edit question &amp; resend</q-tooltip></q-btn>
                                    <div class="question-bubble q-pa-sm bg-grey-2">{{msg.question}}</div>
                                </div>
                            </div>

                            <!-- Thought trace chat bubble -->
                            <div v-if="traceSteps(msg).length" class="flex full-width justify-start q-pl-sm q-mt-sm">
                                <div class="answer-bubble q-pa-sm">
                                    <ThoughtTrace :data="traceSteps(msg)" :loading="msg?.loading" :answered="answerChunks(msg).length > 0" @setscroll="setChatScroll"/>
                                    <q-spinner-dots v-if="msg.loading === true && !answerChunks(msg).length" size="24px" color="secondary" class="q-mx-sm"/>
                                </div>
                            </div>

                            <!-- Answer chat bubble -->
                            <div v-if="answerChunks(msg).length || (msg.loading === true && !traceSteps(msg).length)" class="flex full-width justify-start q-pl-sm q-mt-sm">
                                <div class="answer-bubble q-pa-sm">
                                    <AgentTrustScoreButton v-if="trustScoreChunk(msg) && msg.loading !== true" :scores="trustScoreChunk(msg).critic_scores || []" :error="trustScoreChunk(msg).critic_error || ''" class="answer-trust-score"/>
                                    <div v-for="(chunk, chunkIndex) in answerChunks(msg)" :key="chunkIndex">
                                        <!-- TEXT -->
                                        <template v-if="chunk.text">
                                            <div v-for="(text, textIndex) in chunk.text" :key="textIndex" v-html="markdownToHtml(text)" class="recommendation-markdown text-black"></div>
                                        </template>

                                        <!-- CHARTS -->
                                        <template v-if="chunk.charts">
                                            <div v-for="(chart, chartIndex) in chunk.charts" :key="chartIndex" class="chart-thumb-wrap q-mt-sm">
                                                <div class="chart-thumb" @click="expandChart(chart, chatAttachmentName(msg, 'chart', chartIndex))">
                                                    <PlotlyChart :chart-data="chart" size="small"/>
                                                    <q-icon name="zoom_out_map" size="14px" class="chart-thumb-icon"/>
                                                    <q-tooltip anchor="top middle" self="bottom middle" :offset="[0, 6]" class="bg-grey-9" style="font-size: 10px;">Click to expand the chart</q-tooltip>
                                                </div>
                                                <q-btn flat dense icon="download" size="xs" class="chart-download-btn" @click="downloadChart(chart, chatAttachmentName(msg, 'chart', chartIndex))">
                                                    <q-tooltip anchor="top middle" self="bottom middle" :offset="[0, 6]" class="bg-grey-9" style="font-size: 10px;">Download as image</q-tooltip>
                                                </q-btn>
                                            </div>
                                        </template>

                                        <!-- TABLE -->
                                        <div v-if="chunk.table" v-for="(table, tableIndex) in chunk.table" :key="tableIndex">
                                            <ChatTable :table="table" :download-file-name="chatAttachmentName(msg, 'table', tableIndex)" :style="`max-width: calc(100vw*${chatPanelWidthValue} - 40px);`"/>
                                        </div>

                                        <!-- ERROR MESSAGES -->
                                        <div v-if="chunk.is_error" class="flex items-center text-negative">{{ chunk.error_message }}</div>

                                        <!-- NEXT QUESTIONS -->
                                        <div v-if="chunk.next_questions?.length" class="q-mt-sm">
                                            <div style="font-size: 9px; font-weight: 700; letter-spacing: 1px; padding-bottom: 6px; border-top: 1px solid #ffd3c0; padding-top: 8px; color: #424242;">MORE TO EXPLORE</div>
                                            <div v-for="(question, questionIndex) in chunk.next_questions" :key="question" class="suggested-question" :style="`margin-bottom: ${questionIndex === chunk.next_questions.length - 1 ? '0' : '6px'};`" @click="askSuggestedQuestion(question)">{{ question }}</div>
                                        </div>
                                    </div>

                                    <!-- LOADING -->
                                    <template v-if="msg.loading === true">
                                        <q-spinner-dots size="24px" color="secondary" class="q-mx-sm"/>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-else class="flex full-width justify-center items-center q-py-lg">
                    <q-spinner color="accent" size="20px" class="q-mr-md"/>
                    <div style="font-size: 12px; color: #5f5f5f;">Loading chat...</div>
                </div>
                <div style="height: 8px;"></div>
            </q-scroll-area>

            <!-- DEFAULT QUESTIONS -->
            <div v-if="defaultQuestions.length && qna.length === 0" ref="defaultQuestionsSection" class="full-width q-px-md q-py-sm" style="border-top: 1px solid #dedede; position: relative;">
                <q-resize-observer @resize="updateDefaultQuestionsHeight"/>
                <div style="color: #424242; font-size: 9px; font-weight: 700; letter-spacing: 1px; padding-bottom: 8px; border-bottom: 1px solid #eeeeee;">TRY ASKING</div>
                <div v-for="(question, index) in defaultQuestions" :key="question" class="suggested-question" :style="`margin-bottom: ${index === defaultQuestions.length - 1 ? '0' : '8px'};`" @click="askSuggestedQuestion(question)">{{ question }}</div>
            </div>

            <div class="flex full-width items-center q-py-sm q-pr-sm" style="border-top: 1px solid #dedede;">
                <div class="col q-mx-sm">
                    <TextInput v-model="text" placeholder="e.g. what is the BCO rule?" style="width: calc(100% / 0.85); max-width: calc(100% / 0.85); transform: scale(0.85); transform-origin: left;" @keydown.enter.prevent="handleSend"/>
                </div>
                <q-btn unelevated color="accent" icon="send" size="sm" class="q-py-none q-px-sm" style="border-radius: 6px;" :disable="!text.trim() || isGenerating" @click="handleSend"/>
            </div>
        </div>

        <!-- EXPANDED CHART POPUP -->
        <q-dialog v-model="isChartExpanded" @hide="expandedChart = null">
            <q-card style="width: 70vw; max-width: 1100px; border-radius: 8px;">
                <div class="flex full-width justify-between items-center q-py-sm q-pl-md q-pr-sm" style="border-bottom: 1px solid #dedede;">
                    <div style="font-size: 12px; font-weight: 600;">Chart</div>
                    <div>
                        <q-btn flat icon="download" size="xs" color="grey-8" class="q-py-none q-px-xs q-mr-sm" style="border-radius: 6px;" @click="downloadChart(expandedChart, expandedChartFileName)"><q-tooltip>Download as image</q-tooltip></q-btn>
                        <q-btn flat icon="close" size="xs" color="grey-8" class="q-py-none q-px-xs" style="border-radius: 6px;" @click="expandedChart = null"/>
                    </div>
                </div>
                <div class="full-width q-pa-md">
                    <PlotlyChart v-if="expandedChart" :chart-data="expandedChart" size="large" />
                </div>
            </q-card>
        </q-dialog>

        <!-- HCP COHORT SIZE TREND POPUP -->
        <q-dialog v-model="showCohortTrend">
            <q-card style="width: 70vw; max-width: 1100px; border-radius: 8px;">
                <div class="flex full-width justify-between items-center q-py-sm q-pl-md q-pr-sm" style="border-bottom: 1px solid #dedede;">
                    <div>
                        <div style="font-size: 12px; font-weight: 600;">HCP Cohort Size Trend</div>
                        <div class="q-mt-xs" style="color: #8d8d8d; font-size: 10px; font-style: italic;">last 3 weeks and the current week</div>
                    </div>
                    <q-btn flat icon="close" size="xs" color="grey-8" class="q-py-none q-px-xs self-start" style="border-radius: 6px;" @click="showCohortTrend = false"/>
                </div>
                <div class="full-width q-pa-md">
                    <CohortTrendChart :trend="cohortSizeTrend" size="large" height="360px"/>
                </div>
            </q-card>
        </q-dialog>

        <!-- OLD CHATS POPUP -->
        <q-dialog v-model="showOlderChats" @show="getChatList" @hide="showOlderChats = false; editingChatId = null;">
            <q-card style="width: 420px; max-width: 90vw; border-radius: 8px;">
                <div class="flex full-width justify-between items-center q-py-sm q-pl-md q-pr-sm" style="border-bottom: 1px solid #dedede;">
                    <div style="font-size: 12px; font-weight: 600;">Older Chats</div>
                    <q-btn flat icon="close" size="xs" color="grey-8" class="q-py-none q-px-xs" style="border-radius: 6px;" @click="showOlderChats = false"/>
                </div>

                <q-scroll-area class="q-pr-md q-pl-sm" :thumb-style="thumbStyle" :horizontal-offset="[0, 4]" style="height: min(65vh, 420px); width: 100%;">
                    <template v-if="loadingChatList">
                        <div class="flex full-width justify-center items-center q-py-lg">
                            <q-spinner color="accent" size="20px" class="q-mr-md"/>
                            <div style="font-size: 12px; color: #5f5f5f;">Loading chats...</div>
                        </div>
                    </template>

                    <template v-else-if="sortedChatList.length">
                        <div v-for="chat in sortedChatList" :key="`old-chat-${chat.chat_id}`" class="old-chat-row" :class="{ 'old-chat-row--selected': chat_id === chat.chat_id }" @click="handleOldChatClick(chat)">
                            <template v-if="editingChatId === chat.chat_id">
                                <input
                                    v-model="editingChatNameInput"
                                    class="old-chat-name-input"
                                    ref="renameInput"
                                    @click.stop
                                    @keydown.enter.prevent="confirmEditChatName(chat)"
                                    @keydown.esc.prevent="editingChatId = null"
                                />
                                <q-btn flat dense icon="check" size="xs" color="positive" class="q-ml-xs" @click.stop="confirmEditChatName(chat)"><q-tooltip>Save</q-tooltip></q-btn>
                                <q-btn flat dense icon="close" size="xs" color="grey-8" @click.stop="editingChatId = null"><q-tooltip>Cancel</q-tooltip></q-btn>
                            </template>
                            <template v-else>
                                <div class="old-chat-name">{{ chat.chat_name || "New Chat" }}</div>
                                <q-btn flat dense icon="edit" size="xs" color="grey-6" class="old-chat-action-btn q-mr-xs" @click.stop="startEditChatName(chat)"><q-tooltip>Rename chat</q-tooltip></q-btn>
                                <q-btn flat dense icon="push_pin" size="xs" :color="chat.pinned ? 'accent' : 'grey-6'" class="old-chat-action-btn q-mr-xs" :class="{ 'is-visible': chat.pinned }" @click.stop="pinchat(chat)"><q-tooltip>{{ chat.pinned ? 'Unpin chat' : 'Pin chat' }}</q-tooltip></q-btn>
                                <q-btn flat dense icon="delete" size="xs" color="grey-6" class="old-chat-action-btn" @click.stop="confirmDeleteOldChat(chat)"><q-tooltip>Delete chat</q-tooltip></q-btn>
                            </template>
                        </div>
                    </template>

                    <template v-else>
                        <div class="flex full-width justify-center items-center q-py-lg">
                            <div style="font-size: 12px; color: #5f5f5f;">No older chats yet</div>
                        </div>
                    </template>
                </q-scroll-area>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import APIService from '../../APIService.js';
import SingleSelect from '@/components/SingleSelect.vue';
import TextInput from '@/components/TextInput.vue';
import ThresholdRangeSlider from '@/components/ThresholdRangeSlider.vue';
import ChatTable from '@/components/ChatTable.vue';
import PlotlyChart from '@/components/PlotlyChartsComponent.vue';
import { chatAttachmentFileName, downloadChartImage } from '@/chatDownloads.js';
import CohortTrendChart from '@/components/CohortTrendChart.vue';
import ThoughtTrace from '@/components/ThoughtTrace.vue';
import AgentTrustScoreButton from '@/components/AgentTrustScoreButton.vue';
import { isTrustScoreChunk, storedAgentTrustScores } from '@/agentTrustScores.js';
import SIThoughtTrace from '@/components/SIThoughtTrace.vue';
import BCOThoughtTrace from '@/components/BCOThoughtTrace.vue';
import ThresholdSlider from '@/components/ThresholdSlider.vue';
import { authenticatedFetch } from "@/auth.js"
import { rememberTriggeredBco } from '@/triggeredBcos.js';
import { bcoRunStatus, publishBcoRunStatus } from '@/bcoRunStatus.js';
import { hasSeenSiThoughtTrace, rememberSiThoughtTrace } from '@/seenSiTraces.js';
import { hasSeenBcoThoughtTrace, rememberBcoThoughtTrace } from '@/seenBcoTraces.js';

// Every cohort simulator the view can render, keyed by its label. One key per simulator: the
// bounds arrive under it in `cohortSimulatorRanges`, and the chosen threshold travels to the agent
// and is stored in BCO_MASTER.UPDATED_THRESHOLDS under the same key.
const COHORT_SIMULATORS = {
    market_volume: "Market Volume",
    competitor_trx: "Competitor TRx",
    competitor_2g_tki_trx: "2G TKI Competitor TRx",
    competitor_imatinib_trx: "Imatinib Competitor TRx",
    rep_call_count: "Rep Call Count",
    cml_diagnosed_count: "CML Diagnosed Count",
    cml_diagnosed_patients: "CML Diagnosed Patients",
    market_patient_volume: "Market Patient Volume",
    brand_patient_volume: "Brand Patient Volume",
    new_diagnosed_patients: "New Diagnosed Patients",
    suspected_diagnosed_patients: "Suspected Diagnosed Patients",
    bcr_abl_patients: "BCR ABL Patients",
    brand_nbrx: "Brand NBRx",
    dasatinib_trx: "Dasatinib TRx",
    dasatinib_1st_lot_patients: "Dasatinib 1st LOT Patients",
    dasatinib_2nd_lot_patients: "Dasatinib 2nd LOT Patients",
    dasatinib_3rd_lot_patients: "Dasatinib 3rd LOT Patients",
    payer_access: "Payer Access",
    pct_patients_with_pa: "% Patients with PA",
    pct_patients_with_step_edits: "% Patients with Step Edits",
};

// Simulators whose bounds are fractions; every other slider moves in whole steps.
const SIMULATOR_STEPS = {
    pct_patients_with_pa: 0.01,
    pct_patients_with_step_edits: 0.01,
};
const DEFAULT_SIMULATOR_STEP = 1;

// An agent-generated BCO not in the mapping below — its rule is written on the fly — gets the
// three levers that apply to any rule.
const AGENT_BCO_SIMULATORS = ["market_volume", "competitor_trx", "rep_call_count"];

// The simulators of the agent-generated BCOs that have a curated set, keyed by normalized name.
const AGENT_BCO_SIMULATORS_BY_NAME = {
    "convert dasatinib loe prescribers": ["dasatinib_1st_lot_patients", "dasatinib_trx", "rep_call_count"],
    "target pre-generic switch candidates": ["dasatinib_2nd_lot_patients", "dasatinib_3rd_lot_patients", "dasatinib_trx"],
    "prioritize formulary-vulnerable writers": ["payer_access", "dasatinib_trx", "competitor_trx"],
    "confirmatory testing opportunity": ["bcr_abl_patients", "cml_diagnosed_patients", "brand_nbrx"],
    "routine screening converters": ["bcr_abl_patients", "new_diagnosed_patients", "cml_diagnosed_patients"],
    "reactivate pa eased writers": ["pct_patients_with_pa", "pct_patients_with_step_edits", "competitor_trx"],
};

// The simulators each existing BCO exposes, keyed by its normalized name. BCO names are unique
// across the imperatives, so the imperative itself is not part of the key.
const EXISTING_BCO_SIMULATORS = {
    "convert 2g tki loyalists": ["competitor_2g_tki_trx", "market_volume", "rep_call_count"],
    "convert imatinib loyalists": ["competitor_imatinib_trx", "market_volume", "rep_call_count"],
    "convert splitters": ["competitor_trx", "market_volume", "rep_call_count"],
    "new writer activation": ["cml_diagnosed_count", "market_volume", "rep_call_count"],
    "newly diagnosed opportunity": ["new_diagnosed_patients", "cml_diagnosed_patients", "brand_patient_volume"],
    "suspected diagnosis opportunity": ["suspected_diagnosed_patients", "cml_diagnosed_patients", "brand_patient_volume"],
    "suspected diagnosed opportunity": ["suspected_diagnosed_patients", "cml_diagnosed_patients", "brand_patient_volume"],
};

// The bounds of a simulator the config has nothing to say about.
const FALLBACK_SIMULATOR_RANGE = { min: 0, max: 100 };
const FALLBACK_LOOKBACK_RANGE = { min: 1, max: 13 };

// The lookback period has its own card rather than a simulator slider, but it rides along in the
// same thresholds object.
const LOOKBACK_KEY = "lookback_period_weeks";

const normalizeBcoName = (name) => String(name || "").trim().toLowerCase().replace(/\s+/g, " ");

// The feasibility agent writes its progress straight into BCO_MASTER, so a run is followed
// by re-reading that column rather than by a stream.
const BCO_TRACE_POLL_INTERVAL_MS = 5000;

// Short enough that the panel settles well before the trace reveals its next line.
const TRACE_SCROLL_DURATION_MS = 300;

const DEFAULT_LOOKBACK_PERIOD_WEEKS = 4;
const LOOKBACK_PERIOD_OPTIONS = [
    { label: "1 week", value: 1 },
    { label: "4 weeks", value: 4 },
    { label: "13 weeks", value: 13 },
];
const LOOKBACK_ALLOWED_VALUES = LOOKBACK_PERIOD_OPTIONS.map((option) => option.value);

function snapLookbackPeriod(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
        return DEFAULT_LOOKBACK_PERIOD_WEEKS;
    }

    return LOOKBACK_ALLOWED_VALUES.reduce((closest, allowed) => (
        Math.abs(allowed - numeric) < Math.abs(closest - numeric) ? allowed : closest
    ));
}

export default {
    name: 'StrategizeView',

    components: {
        SingleSelect,
        TextInput,
        ThresholdRangeSlider,
        ChatTable,
        PlotlyChart,
        CohortTrendChart,
        ThoughtTrace,
        AgentTrustScoreButton,
        SIThoughtTrace,
        BCOThoughtTrace,
        ThresholdSlider,
    },

    data() {
        return {
            // The view is kept alive while the user is on another screen, so it has to know
            // when its DOM is detached: every height reads as 0 until it is shown again.
            isViewActive: true,

            isChatOpen: false,
            text: "",
            defaultQuestions: [],
            defaultQuestionsHeight: 0,
            scrollHeight: 0,
            qna: [],
            // Covers the whole request, so switching chats mid-stream can't re-enable sending.
            isAwaitingAnswer: false,
            chat_id: null,
            chatList: [],
            expandedChart: null,
            expandedChartFileName: "",
            chat_name: "New Chat",
            editedChatName: "New Chat",
            showOlderChats: false,
            loadingOldChat: false,
            loadingChatList: false,
            editingChatId: null,
            editingChatNameInput: "",
            editingQnaKey: null,
            editingQuestionText: "",


            isBCOPanelOpen: true,
            selectedCycle: null,
            selectedBrand: null,
            selectedStrategicImperative: null,
            additionalContext: "",
            cycleOptions: [],
            brandOptions: [],
            strategicImperativeOptions: [],
            bcos: [],
            loadingBcos: false,
            // Written by the workbench as runs start and finish; see the watcher below.
            bcoRunStatus,
            siThoughtTrace: [],
            isSiThoughtTraceComplete: false,

            thumbStyle: {
                borderRadius: '7px',
                backgroundColor: '#E5E8ED',
                width: '7px',
                opacity: 0.99
            },

            chipBGMapping: {
                "Feasible": "#edf6f0",
                "Caveat": "#fdf4e5",
                "Blocked": "#fbedeb",
            },

            chipTextMapping: {
                "Feasible": "#2e7d46",
                "Caveat": "#b36a00",
                "Blocked": "#b02a1a",
            },

            dataFeasibilityIconMapping: {
                "Feasible": "check_circle",
                "Caveat": "error",
                "Blocked": "cancel",
            },

            recommendationTextMapping: {
                "Feasible": "Recommended to run",
                "Caveat": "Run with caveats",
                "Blocked": "Not feasible at these settings",
            },

            selectedBcoId: null,
            selectedBco: null,

            bcoThoughtTrace: [],
            isBcoThoughtTraceComplete: false,
            isBcoAgentRunning: false,
            animateBcoThoughtTrace: true,
            // A re-simulation only refreshes cards the user is already reading, so its trace
            // plays above them instead of replacing them.
            keepBcoDetailsVisible: false,
            // Bumped on every replay and every agent run so the trace remounts on a clean slate.
            bcoThoughtTraceRunId: 0,
            bcoTracePollTimer: null,

            lookbackPeriodOptions: LOOKBACK_PERIOD_OPTIONS,
            lookbackAllowedValues: LOOKBACK_ALLOWED_VALUES,
            // Filled from /common/strategize-options; a simulator the config does not cover falls
            // back to FALLBACK_SIMULATOR_RANGE.
            cohortSimulatorRanges: {},
            // Only ever holds the keys of the simulators on screen for the selected BCO, plus the
            // lookback period, because that is exactly what is stored against the BCO.
            cohortThresholds: {
                [LOOKBACK_KEY]: DEFAULT_LOOKBACK_PERIOD_WEEKS,
            },
            resettingCohort: false,
            resettingLookbackPeriod: false,
            triggeringRun: false,

            data_feasibility: [],
            cohort_waterfall: [],
            recommendation_message: "",
            showCohortTrend: false,
        };
    },

    async created() {
        try {
            const response = await APIService.post(`${process.env.VUE_APP_ROOT_API}/common/strategize-options`, {});
            this.cycleOptions = response.data.cycleOptions;
            this.brandOptions = response.data.brandOptions;
            this.strategicImperativeOptions = response.data.strategicImperativeOptions;
            this.selectedCycle = this.cycleOptions[0];
            this.selectedBrand = this.brandOptions[0];
            this.cohortSimulatorRanges = response.data.cohortSimulatorRanges || {};
            this.defaultQuestions = response.data.defaultQuestions;
        } catch (error) {
            console.error(error);
            this.$q.notify({
                message: "Error loading options",
                color: "negative",
                icon: "error",
                position: "top-right",
                timeout: 3000,
            });
        }
    },

    // Cohort simulations and chat answers started here keep running while the user is on
    // another screen; these hooks only re-measure what a detached DOM could not.
    activated() {
        this.isViewActive = true;
        this.updateDefaultQuestionsHeight();
        this.$nextTick(() => {
            if (this.isChatOpen) {
                this.setScrollHeight();
                this.animateScroll(0);
            }
        });
    },

    unmounted() {
        this.stopBcoTracePolling();
    },

    deactivated() {
        this.isViewActive = false;
        // Both dialogs render through a portal on <body>, which would otherwise stay on
        // screen over the next route when navigation happens outside of them.
        this.expandedChart = null;
        this.showOlderChats = false;
        this.showCohortTrend = false;
    },

    computed: {
        bcoPanelWidth() {
            return this.isBCOPanelOpen ? '280px' : '40px';
        },
        chatPanelWidth() {
            if (!this.isChatOpen) return '0px';
            return this.isBCOPanelOpen ? '28%' : '35%';
        },
        chatPanelWidthValue() {
            if (!this.isChatOpen) return '0';
            return this.isBCOPanelOpen ? '0.28' : '0.35';
        },
        chatScrollHeight() {
            // 167px = chat panel header + input row; the suggestions block is measured at runtime
            const suggestionsHeight = this.qna.length === 0 ? this.defaultQuestionsHeight : 0;
            return `calc(100vh - ${167 + suggestionsHeight}px)`;
        },
        // The BCOs stay hidden while the imperative's thought trace plays out, so the panel
        // reveals them as the conclusion of the trace rather than alongside it.
        showBcoList() {
            return !this.siThoughtTrace.length || this.isSiThoughtTraceComplete;
        },
        // A run that has not written a step yet still counts, so the card is on screen from
        // the moment Submit or Reset is pressed.
        hasBcoThoughtTrace() {
            return this.bcoThoughtTrace.length > 0 || this.isBcoAgentRunning;
        },
        // On a first open the BCO cards are the conclusion of the trace, the same way the BCO
        // list is the conclusion of the imperative's trace. A Submit or a Reset instead leaves
        // them on screen, so the two cards the simulation rewrites can carry their own spinner.
        showBcoDetails() {
            return this.keepBcoDetailsVisible || !this.hasBcoThoughtTrace || this.isBcoThoughtTraceComplete;
        },
        // Chats are stored per BCO and talk about its cohort, which a blocked BCO does not have.
        canChatAboutBco() {
            return Boolean(this.selectedBco) && this.showBcoDetails && this.selectedBco.status !== 'Blocked';
        },
        existingBcos() {
            return this.bcos.filter(bco => bco.type === "existing");
        },
        agentRecommendedBcos() {
            return this.bcos.filter(bco => bco.type === "agent-recommended");
        },
        strategySelectStepIndex() {
            return this.selectedStrategicImperative ? 1 : 0;
        },
        sortedChatList() {
            // The API already returns pinned chats first; re-sorting keeps that order after a local pin toggle.
            return [...this.chatList].sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0));
        },
        isGenerating() {
            return this.isAwaitingAnswer || this.qna.some(msg => msg.loading === true);
        },
        // Each BCO carries its own simulation flag, so a simulation started on one BCO
        // does not put the cards of another BCO into a loading state.
        isSimulatingCohort() {
            return Boolean(this.selectedBco?.loadingCohortSimulation);
        },
        recommendationTrustScores() {
            return storedAgentTrustScores(this.selectedBco?.trust_score_bco_generation_agent);
        },
        // The feasibility agent rescores on every submit and reset, and the refreshed BCO
        // replaces `selectedBco`, so these always follow the latest run.
        feasibilityTrustScores() {
            return storedAgentTrustScores(this.selectedBco?.trust_score_feasibility_agent);
        },
        // { weeks: [...], cohort_sizes: [...] } straight out of BCO_MASTER.HISTORICAL_HCP_COHORT.
        cohortSizeTrend() {
            return this.selectedBco?.historical_hcp_cohort || null;
        },
        // A BCO that has never been run has no history to plot, so it gets no trend button.
        hasCohortSizeTrend() {
            const trend = this.cohortSizeTrend;
            if (!trend) return false;

            let parsed = trend;
            if (typeof parsed === "string") {
                try {
                    parsed = JSON.parse(parsed);
                } catch {
                    return false;
                }
            }

            return Array.isArray(parsed?.cohort_sizes) && parsed.cohort_sizes.length > 0;
        },
        isChartExpanded: {
            get() {
                return Boolean(this.expandedChart);
            },
            set(value) {
                if (!value) {
                    this.expandedChart = null;
                }
            },
        },
        lookbackRange() {
            return this.simulatorRange(LOOKBACK_KEY, FALLBACK_LOOKBACK_RANGE);
        },
        // The simulators of the open BCO, each already carrying the bounds its slider runs on.
        visibleCohortSimulators() {
            return this.simulatorsForBco(this.selectedBco);
        },
        // Defaults are the widest cohort the simulators allow, so a reset always
        // hands the agent the full available range.
        defaultCohortThresholds() {
            const defaults = { [LOOKBACK_KEY]: DEFAULT_LOOKBACK_PERIOD_WEEKS };
            this.visibleCohortSimulators.forEach((simulator) => {
                defaults[simulator.key] = { min: simulator.range.min, max: simulator.range.max };
            });
            return defaults;
        },
        areCohortThresholdsEqualToDefaults() {
            return this.visibleCohortSimulators.every((simulator) => {
                const current = this.cohortThresholds[simulator.key];
                return current?.min === simulator.range.min && current?.max === simulator.range.max;
            });
        },
        lastCreatedAtDate() {
            // take the last created_at date from the bcos array and format as "MMM d, yyyy"
            if (!this.bcos.length) {
                return "";
            }
            return new Date(this.bcos[this.bcos.length - 1].created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
        }
    },

    watch: {
        // Collapsing the panel drops the imperative's trace mid-reveal, and the reveal is not
        // played a second time, so the trace counts as seen from that point on.
        isBCOPanelOpen(isOpen) {
            if (!isOpen && this.siThoughtTrace.length) {
                this.markSiThoughtTraceSeen();
            }
        },

        // The workbench is where a run is followed to its end, and this view is kept alive behind
        // it holding its own copy of the BCOs, so a run that finishes there has to be reflected
        // here too — otherwise the card would offer to run an objective that has already run.
        bcoRunStatus: {
            deep: true,
            handler() {
                this.bcos.forEach((bco) => {
                    const runningStatus = this.bcoRunStatus[String(bco.bco_id)];
                    if (runningStatus) {
                        bco.running_status = runningStatus;
                    }
                });
            },
        },
    },

    methods: {
        // The reveal plays once per imperative. It is remembered across reloads, so returning to
        // the imperative later lands on the finished, collapsed trace.
        markSiThoughtTraceSeen() {
            this.isSiThoughtTraceComplete = true;
            rememberSiThoughtTrace(this.selectedCycle, this.selectedBrand, this.selectedStrategicImperative);
        },

        updateDefaultQuestionsHeight() {
            this.$nextTick(() => {
                const el = this.$refs.defaultQuestionsSection;
                // offsetHeight instead of the observer payload so the top border is included
                this.defaultQuestionsHeight = el ? el.offsetHeight : 0;
            });
        },

        getBCOStatus(data_feasibility) {
            if (!data_feasibility?.length) {
                return "Blocked";
            }
            // if any of the data_feasibility[i].status is "Blocked", return "Blocked"
            for (let i = 0; i < data_feasibility?.length; i++) {
                if (data_feasibility[i].status === "Blocked") {
                    return "Blocked";
                }
            }
            // if any of the data_feasibility[i].status is "Caveat", return "Caveat"
            for (let i = 0; i < data_feasibility?.length; i++) {
                if (data_feasibility[i].status === "Caveat") {
                    return "Caveat";
                }
            }
            // only if all the data_feasibility[i].status is "Feasible", return "Feasible"
            for (let i = 0; i < data_feasibility?.length; i++) {
                if (data_feasibility[i].status !== "Feasible") {
                    return "Blocked";
                }
            }
            return "Feasible";
        },

        checkBCOBclockedDueToNoHCPs() {
            // If selected bco status from data feasibility is coming up as feasible and the final hcp count is 0 then return true else return false
            let isFeasible = false;
            for (let i = 0; i < this.data_feasibility?.length; i++) {
                if (this.data_feasibility[i].status === "Feasible") {
                    isFeasible = true;
                }
            }
            if (isFeasible && this.cohort_waterfall[this.cohort_waterfall.length - 1][1] === 0) {
                return true;
            }
            return false;
        },

        simulatorRange(simulatorKey, fallback = FALLBACK_SIMULATOR_RANGE) {
            const range = this.cohortSimulatorRanges?.[simulatorKey];
            return {
                min: Number(range?.min ?? fallback.min),
                max: Number(range?.max ?? fallback.max),
            };
        },

        // A BCO in its type's curated mapping exposes the levers its rule is written against; any
        // other BCO, existing or agent-generated, falls back to the generic agent set.
        simulatorsForBco(bco) {
            if (!bco) {
                return [];
            }

            const curated = bco.type === "existing" ? EXISTING_BCO_SIMULATORS : AGENT_BCO_SIMULATORS_BY_NAME;
            const simulatorKeys = curated[normalizeBcoName(bco.name)] || AGENT_BCO_SIMULATORS;

            return simulatorKeys
                .filter((key) => COHORT_SIMULATORS[key])
                .map((key) => ({
                    key,
                    label: COHORT_SIMULATORS[key],
                    range: this.simulatorRange(key),
                    step: SIMULATOR_STEPS[key] ?? DEFAULT_SIMULATOR_STEP,
                }));
        },

        // Only the simulators of this BCO survive, so a key left over from an earlier mapping never
        // reaches a slider or the agent. The agent can store only the lookback period, and a
        // simulator it has nothing for opens on the full available range.
        pickBcoThresholds(bco, thresholds) {
            const picked = {
                [LOOKBACK_KEY]: snapLookbackPeriod(thresholds?.[LOOKBACK_KEY] ?? DEFAULT_LOOKBACK_PERIOD_WEEKS),
            };

            this.simulatorsForBco(bco).forEach((simulator) => {
                const value = thresholds?.[simulator.key];
                picked[simulator.key] = value?.min !== undefined && value?.max !== undefined
                    ? { min: value.min, max: value.max }
                    : { min: simulator.range.min, max: simulator.range.max };
            });

            return picked;
        },

        // A BCO with nothing stored keeps its `null` so the caller can tell it apart from a BCO
        // whose thresholds are simply at their defaults.
        normalizeBcoThresholds(bco, thresholds) {
            if (!thresholds) {
                return thresholds;
            }

            return this.pickBcoThresholds(bco, thresholds);
        },

        handleBcoCardClick(bcoId) {
            // Re-clicking the open BCO would otherwise replay its trace and hide the cards
            // the user is already reading.
            if (this.selectedBcoId === bcoId) {
                return;
            }

            this.stopBcoTracePolling();
            this.selectedBcoId = bcoId;
            this.selectedBco = this.bcos.find(bco => bco.bco_id === bcoId);

            this.cohortThresholds = this.pickBcoThresholds(this.selectedBco, this.selectedBco?.updated_thresholds);

            this.data_feasibility = this.selectedBco?.updated_data_feasibility || this.selectedBco.data_feasibility;
            this.cohort_waterfall = this.selectedBco?.updated_cohort_waterfall || this.selectedBco.cohort_waterfall;
            this.recommendation_message = this.selectedBco?.updated_recommendation_message || this.selectedBco.recommendation_message;
            this.replayBcoThoughtTrace(this.selectedBco?.strategize_thought_trace);
            this.createNewChat();
            this.isChatOpen = false;
        },

        // A trace reveals a line at a time and grows past the fold of its panel, so every
        // reveal pulls the panel down to keep the newest line in view. Nothing below the
        // trace is on screen while it plays, which makes the bottom the right place to sit.
        scrollTraceIntoView(scrollAreaRef) {
            this.$nextTick(() => {
                const scrollArea = this.$refs[scrollAreaRef];
                // A detached panel reports a scroll height of 0, and scrolling to that
                // would throw the user back to the top when they return to the screen.
                if (!this.isViewActive || !scrollArea) {
                    return;
                }
                const scrollTarget = scrollArea.getScrollTarget();
                // A re-simulation keeps the cards below the trace on screen, so there the reveal
                // follows the bottom of the trace card rather than the bottom of the panel.
                const traceCard = scrollAreaRef === "bcoDetailScroll" && this.keepBcoDetailsVisible ? this.$refs.bcoTraceCard : null;
                const position = traceCard
                    ? Math.max(0, traceCard.offsetTop + traceCard.offsetHeight - scrollTarget.clientHeight)
                    : scrollTarget.scrollHeight;
                scrollArea.setScrollPosition("vertical", position, TRACE_SCROLL_DURATION_MS);
            });
        },

        // The reveal plays once per BCO. It is remembered across reloads, so reopening the card
        // later lands on the finished, collapsed trace.
        markBcoThoughtTraceSeen() {
            this.isBcoThoughtTraceComplete = true;
            rememberBcoThoughtTrace(this.selectedBcoId);
        },

        // The trace of a past run arrives with the BCO itself, so opening a card only has to
        // play back what is already in memory.
        replayBcoThoughtTrace(trace) {
            this.isBcoAgentRunning = false;
            this.keepBcoDetailsVisible = false;
            this.bcoThoughtTrace = Array.isArray(trace) ? trace : [];
            // A BCO whose reveal has already played comes back finished, so the trace mounts
            // collapsed and the cards are on screen right away.
            this.animateBcoThoughtTrace = !hasSeenBcoThoughtTrace(this.selectedBcoId);
            this.isBcoThoughtTraceComplete = this.bcoThoughtTrace.length === 0 || !this.animateBcoThoughtTrace;
            this.bcoThoughtTraceRunId += 1;
        },

        // A fresh run starts with an empty trace and fills it from Snowflake on a timer,
        // because the agent writes its steps there while it works. Its steps are new work the
        // user has not watched yet, so the reveal plays even for a BCO opened before.
        startBcoAgentThoughtTrace(bcoId) {
            this.stopBcoTracePolling();
            this.bcoThoughtTrace = [];
            this.keepBcoDetailsVisible = true;
            this.animateBcoThoughtTrace = true;
            this.isBcoThoughtTraceComplete = false;
            this.isBcoAgentRunning = true;
            this.bcoThoughtTraceRunId += 1;
            this.bcoTracePollTimer = setInterval(() => this.pollBcoThoughtTrace(bcoId), BCO_TRACE_POLL_INTERVAL_MS);
        },

        // The agent writes its closing steps just before it returns, so the run ends with one
        // more read rather than with whatever the last tick happened to catch.
        async finishBcoAgentThoughtTrace(bcoId) {
            this.stopBcoTracePolling();
            if (this.selectedBcoId !== bcoId || !this.isBcoAgentRunning) {
                return;
            }

            await this.pollBcoThoughtTrace(bcoId);
            if (this.selectedBcoId !== bcoId) {
                return;
            }

            this.isBcoAgentRunning = false;
            // With no steps to reveal there is no trace to wait on before the cards come back.
            if (!this.bcoThoughtTrace.length) {
                this.isBcoThoughtTraceComplete = true;
            }
        },

        async pollBcoThoughtTrace(bcoId) {
            if (this.selectedBcoId !== bcoId) {
                this.stopBcoTracePolling();
                return;
            }

            try {
                const response = await APIService.post(`${process.env.VUE_APP_ROOT_API}/common/bco-strategize-thought-trace`, { bco_id: bcoId });
                const trace = response.data.strategize_thought_trace;
                const steps = Array.isArray(trace) ? trace : [];
                // A slow read can land after the user opened another BCO or after a later
                // run replaced the trace, and it must not be written into either.
                if (this.selectedBcoId !== bcoId || !this.isBcoAgentRunning || steps.length <= this.bcoThoughtTrace.length) {
                    return;
                }
                this.bcoThoughtTrace = steps;
            } catch (error) {
                console.error(error);
            }
        },

        stopBcoTracePolling() {
            clearInterval(this.bcoTracePollTimer);
            this.bcoTracePollTimer = null;
        },

        async resetCohortThresholdsToDefaults() {
            if (!this.selectedBco) {
                return;
            }

            this.resettingCohort = true;
            try {
                // the lookback period has its own reset button, so it keeps its current value
                await this.simulateCohort({
                    ...this.defaultCohortThresholds,
                    lookback_period_weeks: this.cohortThresholds.lookback_period_weeks,
                }, true);
            } finally {
                this.resettingCohort = false;
            }
        },

        async resetLookbackPeriodToDefaults() {
            if (!this.selectedBco) {
                return;
            }

            this.resettingLookbackPeriod = true;
            try {
                await this.simulateCohort({
                    ...this.cohortThresholds,
                    lookback_period_weeks: this.defaultCohortThresholds.lookback_period_weeks,
                }, true);
            } finally {
                this.resettingLookbackPeriod = false;
            }
        },

        async submitCohortThresholds() {
            if (!this.selectedBco) {
                return;
            }

            await this.simulateCohort(this.cohortThresholds, true);
        },

        // The agent behind /update-bco-cohort writes the simulation results itself, so the
        // cards are refreshed from the stored BCO rather than from the response body.
        async simulateCohort(selectedThresholds, updated) {
            const bcoId = this.selectedBcoId;
            // The BCO_MASTER row only ever holds the thresholds of its own simulators, so the
            // payload is narrowed to those keys rather than sent as the caller assembled it.
            const thresholds = this.pickBcoThresholds(this.selectedBco, selectedThresholds);

            this.setCohortSimulationLoading(bcoId, true);
            this.startBcoAgentThoughtTrace(bcoId);
            let notification;
            try {
                this.cohortThresholds = thresholds;
                const payload = {
                    bco_id: bcoId,
                    selected_thresholds: thresholds,
                    bco_rule: this.selectedBco.bco_rule,
                    strategic_imperative: this.selectedStrategicImperative,
                    bco_name: this.selectedBco.name,
                    updated: updated,
                };
                await APIService.post(`${process.env.VUE_APP_ROOT_API}/common/update-bco-cohort`, payload);
                await this.refreshBco(bcoId, thresholds);

                notification = {
                    message: updated ? "Cohort updated successfully" : "Cohort reset to defaults",
                    color: "positive",
                    icon: "check_circle",
                };
            } catch (error) {
                console.error(error);
                notification = {
                    message: updated ? "Error updating cohort" : "Error resetting cohort to defaults",
                    color: "negative",
                    icon: "error",
                };
            } finally {
                // Also covers a failed run: the trace stops where the agent stopped and the
                // cards come out of their loading state rather than staying behind a spinner.
                await this.finishBcoAgentThoughtTrace(bcoId);
                this.setCohortSimulationLoading(bcoId, false);
                // The notification announces the refreshed cards, so it holds until they are
                // on screen.
                await this.waitForBcoDetails(bcoId);
                this.$q.notify({
                    ...notification,
                    position: "top-right",
                    timeout: 3000,
                });
            }
        },

        // Resolves once the BCO cards are rendered, or straight away once the user has moved
        // to another BCO, because then there is nothing left on screen to wait for.
        async waitForBcoDetails(bcoId) {
            const isReady = () => this.selectedBcoId !== bcoId || this.showBcoDetails;
            if (!isReady()) {
                await new Promise(resolve => {
                    const unwatch = this.$watch(isReady, ready => {
                        if (!ready) {
                            return;
                        }
                        unwatch();
                        resolve();
                    });
                });
            }
            await this.$nextTick();
        },

        setCohortSimulationLoading(bcoId, loading) {
            const bco = this.bcos.find(item => item.bco_id === bcoId);
            if (bco) {
                bco.loadingCohortSimulation = loading;
            }
        },

        // Re-reads one BCO and swaps it into the list. `fallbackThresholds` keeps the sliders
        // where the user left them when the agent has not stored any updated thresholds.
        async refreshBco(bcoId, fallbackThresholds = null) {
            const response = await APIService.post(`${process.env.VUE_APP_ROOT_API}/common/get-bco`, { bco_id: bcoId });
            const bco = response.data;
            bco.status = this.getBCOStatus(bco.updated_data_feasibility || bco.data_feasibility);
            bco.updated_thresholds = this.normalizeBcoThresholds(bco, bco.updated_thresholds);

            const index = this.bcos.findIndex(item => item.bco_id === bcoId);
            if (index !== -1) {
                // the refreshed BCO replaces the stored one mid-simulation, so it has to keep its loading flag
                bco.loadingCohortSimulation = Boolean(this.bcos[index].loadingCohortSimulation);
                this.bcos.splice(index, 1, bco);
            } else {
                bco.loadingCohortSimulation = false;
            }

            // The user can move to another BCO while the agent is still simulating.
            if (this.selectedBcoId !== bcoId) {
                return;
            }

            this.selectedBco = bco;
            this.data_feasibility = bco.updated_data_feasibility || bco.data_feasibility;
            this.cohort_waterfall = bco.updated_cohort_waterfall || bco.cohort_waterfall;
            this.recommendation_message = bco.updated_recommendation_message || bco.recommendation_message;
            this.cohortThresholds = this.pickBcoThresholds(bco, bco.updated_thresholds || fallbackThresholds);
        },

        async triggerBcoRun() {
            if (!this.selectedBco) {
                return;
            }

            this.triggeringRun = true;
            try {
                await APIService.post(`${process.env.VUE_APP_ROOT_API}/common/trigger-bco-run`, { bco_id: this.selectedBcoId });
                this.selectedBco.running_status = "running";
                publishBcoRunStatus(this.selectedBcoId, "running");
                rememberTriggeredBco(this.selectedBcoId);
                this.$router.push({ name: "agent-studio" });
            } catch (error) {
                console.error(error);
                this.$q.notify({
                    message: "Error triggering the run for this BCO",
                    color: "negative",
                    icon: "error",
                    position: "top-right",
                    timeout: 3000,
                });
            } finally {
                this.triggeringRun = false;
            }
        },

        async fetchBcos() {
            if(!this.selectedCycle || !this.selectedBrand || !this.selectedStrategicImperative) {
                return;
            }
            this.isBCOPanelOpen = true;
            this.selectedBco = null;
            this.selectedBcoId = null;
            this.stopBcoTracePolling();
            this.replayBcoThoughtTrace([]);
            this.siThoughtTrace = [];
            // An imperative whose reveal has already played comes back finished, so the trace
            // mounts collapsed and the BCO list is on screen right away.
            this.isSiThoughtTraceComplete = hasSeenSiThoughtTrace(this.selectedCycle, this.selectedBrand, this.selectedStrategicImperative);
            this.loadingBcos = true;
            try {
                this.createNewChat();
                this.isChatOpen = false;
                const payload = {
                    cycle: this.selectedCycle,
                    brand: this.selectedBrand,
                    strategic_imperative: this.selectedStrategicImperative,
                };
                const response = await APIService.post(`${process.env.VUE_APP_ROOT_API}/common/get-bcos`, payload);
                this.bcos = response.data.bcos || [];
                this.siThoughtTrace = response.data.thought_trace || [];
                this.bcos.forEach(bco => {
                    bco.status = this.getBCOStatus(bco.updated_data_feasibility || bco.data_feasibility);
                    bco.updated_thresholds = this.normalizeBcoThresholds(bco, bco.updated_thresholds);
                    bco.loadingCohortSimulation = false;
                });
            } catch (error) {
                console.error(error);
                this.$q.notify({
                    message: "Error fetching BCOs",
                    color: "negative",
                    icon: "error",
                    position: "top-right",
                    timeout: 3000,
                });
            } finally {
                this.loadingBcos = false;
            }
        },

        formatRecommendationDate(date) {
            if (!date) {
                return "";
            }

            return new Intl.DateTimeFormat("en-GB", {
                day: "numeric",
                month: "short",
                year: "numeric",
                timeZone: "UTC",
            }).format(new Date(`${date}T00:00:00Z`));
        },

        markdownToHtml(markdown) {
            if (!markdown) {
                return "";
            }

            const escapeHtml = (text) => text
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
            const renderInline = (text) => escapeHtml(text).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
            const lines = markdown.split(/\r?\n/);
            const html = [];
            let listOpen = false;

            lines.forEach((line) => {
                const bullet = line.match(/^\s*[-*]\s+(.+)$/);

                if (bullet) {
                    if (!listOpen) {
                        html.push("<ul>");
                        listOpen = true;
                    }
                    html.push(`<li>${renderInline(bullet[1])}</li>`);
                    return;
                }

                if (listOpen) {
                    html.push("</ul>");
                    listOpen = false;
                }

                if (line.trim()) {
                    html.push(`<p>${renderInline(line.trim())}</p>`);
                }
            });

            if (listOpen) {
                html.push("</ul>");
            }

            return html.join("");
        },

        /* Chat Interface methods */

        toggleChat() {
            this.isChatOpen = !this.isChatOpen;
            this.isBCOPanelOpen = !this.isChatOpen;
        },

        chatAttachmentName(msg, kind, index) {
            return chatAttachmentFileName(this.editedChatName, msg?.key, kind, index + 1);
        },

        expandChart(chart, fileName) {
            this.expandedChart = chart;
            this.expandedChartFileName = fileName;
        },

        async downloadChart(chart, fileName) {
            try {
                await downloadChartImage(chart, fileName);
            } catch(err) {
                console.error("Error downloading chart:", err);
                this.$q.notify({
                    type: 'negative',
                    message: 'Failed to download the chart. Please try again.',
                    position: 'top-right',
                    timeout: 3000,
                });
            }
        },

        createNewChat() {
            try {
                this.text = "";
                this.cancelEditQuestion();
                this.qna = [];
                this.chat_id = null;
                this.chat_name = "New Chat";
                this.editedChatName = "New Chat";
            } catch(err) {
                console.log("Error creating new chat:", err);
            }
        },

        async fetchOldChat(chat) {
            try {
                this.loadingOldChat = true;
                this.showDeleteChat = true;
                this.cancelEditQuestion();
                this.editedChatName = chat.chat_name;
                this.renameChat = false; 
                this.chat_id = chat.chat_id;
                const send = { chat_id: chat.chat_id }
                const t = await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/get-old-chat`, send);
                this.qna = t.data.qna || [];
                this.loadingOldChat = false;
            } catch(err) {
                this.errorMain = true;
            }
        },

        async pinchat(chat) {
            const wasPinned = Boolean(chat.pinned);
            chat.pinned = wasPinned ? 0 : 1;
            try {
                const send = { chat_id: chat.chat_id }
                await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/pin-chat`, send);
            } catch(err) {
                chat.pinned = wasPinned ? 1 : 0;
                this.$q.notify({
                    type: 'negative',
                    message: `Failed to ${wasPinned ? 'unpin' : 'pin'} chat. Please try again.`,
                    position: 'top-right',  
                    timeout: 3000,
                });
            }
        },

        async editChatName(chat_id, chat_name) {
            try {
                let send = {
                    chat_id: chat_id,
                    chat_name: chat_name,
                }
                this.editedChatName = chat_name;
                const t = await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/edit-chat-name`, send);
                this.chatList.find(x => x.chat_id == chat_id).chat_name = chat_name;
            } catch(err) {
                this.$q.notify({
                    type: 'negative',
                    message: 'Failed to rename chat. Please try again.',
                    position: 'top-right',  
                    timeout: 3000,
                });
            } finally {
                this.renameChat = false;
            }
        },

        async handleDeleteChat() {
            try {
                const send = { chat_id: this.chat_id }
                const t = await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/delete-chat`, send);
                if(t.status == 200){
                    await this.getChatList();
                }
                this.showDeleteChat = false
                this.createNewChat();
            } catch(err) {
                this.$q.notify({
                    type: 'negative',
                    message: 'Failed to delete chat. Please try again.',
                    position: 'top-right',  
                    timeout: 3000,
                });
            }
        },

        handleOldChatClick(chat) {
            if (this.editingChatId === chat.chat_id) {
                return;
            }
            this.showOlderChats = false;
            this.fetchOldChat(chat);
        },

        startEditChatName(chat) {
            this.editingChatId = chat.chat_id;
            this.editingChatNameInput = chat.chat_name;
            this.$nextTick(() => {
                const input = this.$refs.renameInput;
                const el = Array.isArray(input) ? input[0] : input;
                el?.focus();
            });
        },

        confirmEditChatName(chat) {
            const newName = this.editingChatNameInput.trim();
            this.editingChatId = null;
            if (!newName || newName === chat.chat_name) {
                return;
            }
            this.editChatName(chat.chat_id, newName);
        },

        confirmDeleteOldChat(chat) {
            if (!window.confirm(`Delete "${chat.chat_name || "New Chat"}"? This cannot be undone.`)) {
                return;
            }
            this.chat_id = chat.chat_id;
            this.handleDeleteChat();
        },

        async createNewChatInDB() {
            try{
                const send = { bco_id: this.selectedBcoId };
                let t = await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/create-new-chat-in-db`, send);
                return t.data.chat_id;
            } catch(err) {
                console.error(err);
            }
        },

        // Shared by the starter chips and the follow-up chips on an answer.
        askSuggestedQuestion(question) {
            if (this.isGenerating) {
                return;
            }
            this.text = question;
            this.handleSend();
        },

        // The question is read and the input cleared before the first await: a second
        // Enter or click during chat creation would otherwise send a stale or empty question.
        async handleSend() {
            if (this.isGenerating) {
                return;
            }
            const question = this.text.trim();
            if (!question) {
                return;
            }
            this.text = "";
            this.isAwaitingAnswer = true;
            let temp_chat_id = null;
            let currentQnaIndex = -1;
            try {
                this.qna.push({
                    loading: true,
                    key: this.qna.length + 1,
                    question: question,
                    feedbacks: [],
                    timestamp: new Date(),
                    answer: [],
                });

                if(this.qna.length == 1){
                    this.chat_id = await this.createNewChatInDB();
                    if (!this.chat_id) {
                        this.qna.pop();
                        this.text = question;
                        return;
                    }
                }
                temp_chat_id = this.chat_id;
                currentQnaIndex = this.qna.length - 1;

                const send = {
                    bco_id: this.selectedBcoId,
                    question: question,
                    chat_id: this.chat_id,
                    regenerate: false,
                    analytics_context: this.result,
                    insight_id: this.insightId,
                    userObj: {
                        emailId: localStorage.getItem("emailId")
                    },
                    url: this.$route.fullPath.split("?")[0]
                };

                await new Promise(r => setTimeout(r, 10));
                this.setChatScroll();
                this.getAndSetChatName(this.chat_id, question);

                const response = await authenticatedFetch(`${process.env.VUE_APP_ROOT_API}/analytics-genie/send-question`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(send),
                })

                await this.streamAnswerIntoQna(response, currentQnaIndex, temp_chat_id);

                if(temp_chat_id === this.chat_id && this.qna.length > currentQnaIndex) {
                    await new Promise(r => setTimeout(r, 100));
                    delete this.qna[currentQnaIndex].loading;
                }
                await new Promise(r => setTimeout(r, 10));
                this.setChatScroll();
            } catch(err) {
                console.error(err);
                // An aborted stream rejects reader.read() rather than reporting done,
                // so the loader has to be cleared here or it spins forever.
                if (currentQnaIndex !== -1 && temp_chat_id === this.chat_id && this.qna.length > currentQnaIndex) {
                    if (!this.qna[currentQnaIndex].answer.some(chunk => chunk.is_error)) {
                        this.qna[currentQnaIndex].answer.push({
                            is_error: true,
                            error_message: "The connection was interrupted before the answer finished. Please try again.",
                        });
                    }
                    delete this.qna[currentQnaIndex].loading;
                }
            } finally {
                this.isAwaitingAnswer = false;
            }
        },

        // Reads the SSE body into qna[qnaIndex].answer. Chunks are dropped once the user
        // has moved to another chat or the entry is gone, so a slow stream can't write
        // into whatever now sits at that index.
        async streamAnswerIntoQna(response, qnaIndex, temp_chat_id) {
            const isStillCurrent = () => temp_chat_id === this.chat_id && this.qna.length > qnaIndex;

            if (!response.ok) {
                if (isStillCurrent()) {
                    this.qna[qnaIndex].answer.push({ is_error: true, error_message: `Request failed with status ${response.status}` });
                }
                return;
            }

            const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
            let buffer = '';

            while(true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += value;
                let lastIndex = buffer.lastIndexOf('\n\n');
                if (lastIndex !== -1) {
                    const completeMessages = buffer.substring(0, lastIndex);
                    buffer = buffer.substring(lastIndex + 2);
                    const messages = completeMessages.split('\n\n');
                    for (const message of messages) {
                        if (!message.trim()) continue;
                        const dataLines = message.split('\n').filter(line => line.startsWith('data:'));
                        if (dataLines.length === 0) continue;
                        const rawData = dataLines.map(line => line.replace(/^data:\s*/, '').trim()).join('');
                        try {
                            if (rawData) {
                                const chunk = JSON.parse(rawData);
                                if (isStillCurrent()) {
                                    this.qna[qnaIndex].answer.push(chunk);
                                }
                            }
                        } catch (e) {
                            console.error("Error parsing response chunk:", e, "Raw data that failed to parse:", rawData);
                            if (isStillCurrent()) {
                                this.qna[qnaIndex].answer.push({ is_error: true, error_message: "Something went wrong while generating the answer. Please try again." });
                            }
                        }
                    }
                }
            }
        },

        startEditQuestion(msg) {
            if (this.isGenerating) {
                return;
            }
            this.editingQnaKey = msg.key;
            this.editingQuestionText = msg.question;
            this.$nextTick(() => {
                const input = this.$refs.editQuestionInput;
                const el = Array.isArray(input) ? input[0] : input;
                if (!el) {
                    return;
                }
                el.focus();
                el.setSelectionRange(el.value.length, el.value.length);
            });
        },

        cancelEditQuestion() {
            this.editingQnaKey = null;
            this.editingQuestionText = "";
        },

        submitEditedQuestion(msg) {
            const question = this.editingQuestionText.trim();
            if (!question || this.isGenerating) {
                return;
            }
            this.cancelEditQuestion();
            this.regenerateResponse(msg.key, question);
        },

        // Re-answers an existing QNA row in place. The backend overwrites the stored
        // question, so the edited text replaces the original instead of appending a turn.
        async regenerateResponse(key, question) {
            const qnaIndex = this.qna.findIndex(msg => msg.key === key);
            if (qnaIndex === -1) {
                return;
            }
            const temp_chat_id = this.chat_id;
            this.isAwaitingAnswer = true;
            try {
                this.qna[qnaIndex] = {
                    loading: true,
                    key: key,
                    question: question,
                    feedbacks: [],
                    timestamp: new Date(),
                    answer: [],
                };

                const send = {
                    bco_id: this.selectedBcoId,
                    question: question,
                    chat_id: this.chat_id,
                    key: key,
                    regenerate: true,
                };

                await new Promise(r => setTimeout(r, 10));
                this.setChatScroll();
                if(key === this.qna.length) {
                    this.getAndSetChatName(this.chat_id, question);
                }

                const response = await authenticatedFetch(`${process.env.VUE_APP_ROOT_API}/analytics-genie/regenerate-response`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(send),
                })

                await this.streamAnswerIntoQna(response, qnaIndex, temp_chat_id);

                if(temp_chat_id === this.chat_id && this.qna.length > qnaIndex) {
                    await new Promise(r => setTimeout(r, 100));
                    delete this.qna[qnaIndex].loading;
                }
                await new Promise(r => setTimeout(r, 10));
                this.setChatScroll();
            } catch(err) {
                console.error(err);
                // An aborted stream rejects reader.read() rather than reporting done,
                // so the loader has to be cleared here or it spins forever.
                if (temp_chat_id === this.chat_id && this.qna.length > qnaIndex) {
                    if (!this.qna[qnaIndex].answer.some(chunk => chunk.is_error)) {
                        this.qna[qnaIndex].answer.push({
                            is_error: true,
                            error_message: "The connection was interrupted before the answer finished. Please try again.",
                        });
                    }
                    delete this.qna[qnaIndex].loading;
                }
            } finally {
                this.isAwaitingAnswer = false;
            }
        },

        async getAndSetChatName(chat_id, question) {
            const send = {
                chat_id: chat_id,
                question: question,
            }
            const index = this.chatList.findIndex(x => x.chat_id == chat_id);
            let oldChatName;
            if(index >= 0) {
                oldChatName = this.chatList[index].chat_name;
            } else {
                oldChatName = "New chat";
            }
            try {
                const [t, _] = await Promise.all([APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/get-chat-name`, send), this.getChatList()]);
                const newChatName = t.data.chat_name;
                const newIndex = this.chatList.findIndex(x => x.chat_id == chat_id);
                this.chatList[newIndex].chat_name = "";
                for(let i=0; i<newChatName.length; i++) {
                    this.chatList[newIndex].chat_name += newChatName[i];
                    await new Promise(r => setTimeout(r, 50));
                }
                this.editedChatName = newChatName;
            } catch(err) {
                this.chatList[index].chat_name = oldChatName;
            }
        },

        animateScroll(duration = 600) {
            this.$refs.chatScroll?.setScrollPosition('vertical', this.scrollHeight, duration);
        },

        setScrollHeight() {
            const scrollArea = this.$refs.chatScroll;
            if (scrollArea) {
                this.scrollHeight = scrollArea.getScrollTarget().scrollHeight;
            }
        },

        traceSteps(msg) {
            return Array.isArray(msg?.answer) ? msg.answer.filter(chunk => chunk?.step_name) : [];
        },

        answerChunks(msg) {
            return Array.isArray(msg?.answer) ? msg.answer.filter(chunk => !chunk?.step_name && !isTrustScoreChunk(chunk)) : [];
        },

        trustScoreChunk(msg) {
            return Array.isArray(msg?.answer) ? msg.answer.find(isTrustScoreChunk) : undefined;
        },

        // An answer can stream in while the user is on another screen. The panel is detached
        // then, so its scroll height is 0 and scrolling is deferred to the next activation.
        setChatScroll() {
            if (!this.isViewActive || !this.isChatOpen) {
                return;
            }
            this.setScrollHeight();
            this.animateScroll();
        },

        async getCountChats() {
            try{
                let t = await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/get-count-chats`, {});
                return t.data;
            } catch(err) {
                this.chatList = [];
                console.error(err);
            }
        },

        async getChatList() {
            try {
                this.loadingChatList = true;
                const t = await APIService.post(`${process.env.VUE_APP_ROOT_API}/analytics-genie/get-chat-list`, { bco_id: this.selectedBcoId });
                this.chatList = t.data.chatList;
                this.loadingChatList = false;
            } catch(err) {
                this.chatList = [];
                this.loadingChatList = false;
                console.error(err);
            }
        },

    },
}
</script>

<style scoped>
.insights-agent-btn {
    flex-shrink: 0;
    height: 40px;
    border-radius: 6px;
    white-space: nowrap;
}

.dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    display: block;
}

.si-trace-card {
    width: calc(100% - 20px);
    margin: 8px 10px 0;
    padding: 8px 10px;
    border: 1px solid #ffd3c0;
    border-radius: 8px;
    background: #fff1ea;
}

.bco-trace-card {
    width: 100%;
    margin-bottom: 16px;
    padding: 10px 16px;
    border: 1px solid #ffd3c0;
    border-radius: 8px;
    background: #fff1ea;
}

.bco-card {
    cursor: pointer;
    border-radius: 8px; 
    border: 1px solid #dedede; 
    padding: 10px;
    margin-top: 8px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    width: 100%;
    transition: all 0.1s ease;
}

.selected {
    border: 2px solid #ff4e00;
    border-left: 4px solid #ff4e00;
}

.bco-card:not(.selected):hover {
    border-color: #707070;
}

.model-value-track {
    position: relative;
    flex: 1;
    margin: 0 30px 0 0;
}

.benchmark-marker {
    position: absolute;
    top: -5px;
    width: 2px;
    height: 22px;
    background: #777;
    transform: translateX(-1px);
}

.benchmark-marker span {
    position: absolute;
    top: -13px;
    left: 50%;
    transform: translateX(-50%);
    color: #8d8d8d;
    font-size: 8px;
    line-height: 1;
    white-space: nowrap;
}

.recommendation-source {
    margin-top: 8px;
    padding: 9px 12px;
    background: #fff;
    border: 1px solid #dedede;
    border-radius: 6px;
}

.recommendation-source-title {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
}

.recommendation-markdown {
    color: #333;
}

.recommendation-markdown :deep(p) {
    display: inline;
    margin: 0;
}

.recommendation-markdown :deep(ul) {
    display: block;
    margin: 4px 0 0;
    padding-left: 18px;
}

.recommendation-markdown :deep(li) {
    line-height: 1.6;
}

.strategy-stepper {
    display: flex;
    align-items: flex-start;
    margin-top: 28px;
}

.strategy-step {
    width: 106px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.strategy-step-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #eeeeee;
    color: #adadad;
    font-size: 12px;
    font-weight: 700;
    line-height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.strategy-step-number.active {
    background: #ff4e00;
    color: #ffffff;
}

.strategy-step-number.completed {
    background: #2e7d46;
    color: #ffffff;
}

.strategy-step-label {
    margin-top: 10px;
    color: #a5a5a5;
    font-size: 12px;
    white-space: nowrap;
}

.strategy-step-label.active {
    color: #414141;
    font-weight: 600;
}

.strategy-step-connector {
    width: 12px;
    height: 1px;
    margin: 14px 5px 0;
    background: #d3d3d3;
}

.answer-bubble {
    max-width: 90%;
    min-width: 0;
    border: 1px solid #ffd3c0;
    border-radius: 8px;
    background: #fff1ea;
    font-size: 11px;
    color: #b33700;
}

.answer-trust-score {
    float: right;
    margin: -2px -2px 2px 8px;
}

.feasibility-trust-score {
    position: absolute;
    top: -2px;
    right: 6px;
}

.recommendation-trust-score {
    position: absolute;
    top: 4px;
    right: 6px;
}

.suggested-question {
    cursor: pointer;
    border: 0.5px solid #424242;
    border-radius: 999px;
    padding: 4px 10px;
    font-size: 10px;
    color: #424242;
    background: #ffffff;
}

.suggested-question:hover {
    border-color: #1f1f1f;
    color: #1f1f1f;
    background: #fff6f0;
}

.cohort-trend-btn {
    position: absolute;
    top: 2px;
    right: 2px;
}

.chart-thumb-wrap {
    position: relative;
    width: 100%;
    max-width: 100%;
    min-width: 0;
}

.chart-download-btn {
    position: absolute;
    top: 4px;
    right: 28px;
    min-height: 0;
    padding: 2px;
    border: 1px solid #ffd3c0;
    border-radius: 4px;
    color: #5f5f5f;
    background: #ffffff;
}

.chart-download-btn:hover {
    border-color: #ff4e00;
    color: #ff4e00;
}

.chart-thumb {
    position: relative;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    cursor: pointer;
    overflow: hidden;
    border: 1px solid #ffd3c0;
    border-radius: 6px;
    background: #ffffff;
    transition: all 0.1s ease;
}

.chart-thumb:hover {
    border-color: #ff4e00;
}

.chart-thumb-icon {
    position: absolute;
    top: 4px;
    right: 4px;
    padding: 3px;
    border-radius: 4px;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: opacity 0.1s ease;
}

.chart-thumb-wrap:hover .chart-thumb-icon {
    opacity: 1;
}

.old-chat-row {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 7px 8px;
    margin-top: 4px;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 6px;
    background: #ffffff;
    transition: all 0.1s ease;
}

.old-chat-row:hover {
    background: #f7f7f7;
    border-color: #dedede;
}

.old-chat-row--selected {
    background: #fff1ea;
    border-color: #ffd3c0;
}

.old-chat-name {
    flex: 1;
    min-width: 0;
    font-size: 12px;
    color: #414141;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.old-chat-row--selected .old-chat-name {
    color: #b33700;
    font-weight: 600;
}

.old-chat-name-input {
    flex: 1;
    min-width: 0;
    font-family: inherit;
    font-size: 12px;
    color: #414141;
    background: #ffffff;
    border: 1px solid #ff4e00;
    border-radius: 4px;
    padding: 2px 6px;
    outline: none;
}

.old-chat-action-btn {
    opacity: 0;
    transition: opacity 0.1s ease;
}

.old-chat-row:hover .old-chat-action-btn,
.old-chat-action-btn.is-visible {
    opacity: 1;
}

.question-block {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    max-width: 90%;
}

/* QScrollArea's content box is absolutely positioned and shrink-to-fit, so wide
   content (a long line of generated code) stretches it and drags the answer
   bubble past the panel edge. Cap it so children scroll within the panel. */
.chat-scroll :deep(.q-scrollarea__content) {
    max-width: 100%;
}

.question-bubble {
    border-radius: 8px;
    border: 1px solid #dedede;
    color: #414141;
    font-size: 11px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.question-edit-btn {
    flex: none;
    opacity: 0;
    transition: opacity 0.1s ease;
}

.question-block:hover .question-edit-btn {
    opacity: 1;
}

.question-edit-box {
    width: 90%;
    border-radius: 8px;
    border: 1px solid #ff4e00;
    background: #ffffff;
}

.question-edit-input {
    display: block;
    width: 100%;
    font-family: inherit;
    font-size: 11px;
    line-height: 1.5;
    color: #414141;
    background: #ffffff;
    border: none;
    outline: none;
    padding: 0;
    resize: vertical;
}
</style>